import api from '../api/client';

const catalogoDetalhadoConfigService = {
  async getConfig(organizadorId) {
    const response = await api.get(`/configuracoes/catalogo-detalhado/${organizadorId}`);
    return response.data;
  },

  async saveConfig(organizadorId, config) {
    const response = await api.post(`/configuracoes/catalogo-detalhado/${organizadorId}`, config);
    return response.data;
  }
};

export default catalogoDetalhadoConfigService;

